import {amber, indigo, lime, pink, red} from "@mui/material/colors";

export const roles = {
	
	/*RUOLI AMMINISTATORI*/
	"ROLE_ADMIN": {
		label: "ETERNO",
		color: "#8a0808",
		textCol: "#FFF",
		avatarColor: "#520404",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Sono una specie di esseri immortali dotati di poteri sovrumani."
	},
	"ROLE_SUPERADMIN": {
		label: "CELESTIALE",
		color: "#0d4c85",
		textCol: "#FFF",
		avatarColor: "#1b2575",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "In principio erano i Celestiali, dèi spaziali giunti sulla Terra per compiere esperimenti genetici. " +
			"Dalla primitiva creatura chiamata uomo trassero due nuove razze: i mostruosi Devianti e i perfetti Eterni, esseri " +
			"simili agli uomini ma dotati di poteri semidivini. In principio erano i Celestiali, che posero il seme. " +
			"Ora è giunto il momento del raccolto."
	},
	
	/*RUOLI GENERICI*/
	"ROLE_ALL": {
		label: "TUTTI I RUOLI", color: amber[500], textCol: "#000", avatarColor: amber[800], visibility: ["ALL"],
		description: "Ruolo generico per la visibilità completa di tutte le categorie all'interno dei ticket."
	},
	"ROLE_GRAFICI": {
		label: "VISIONE REPORT", color: amber[500], textCol: "#000", avatarColor: amber[800], visibility: ["ALL"],
		description: "Ruolo per la visibilità dei report e grafici."
	},
	"ROLE_COMPANY": {
		label: "REFERENTE AZIENDA",
		color: indigo["A700"],
		textCol: "#FFF",
		avatarColor: indigo[900],
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per il referente dell'azienda",
	},
	"ROLE_DELEGATO": {
		label: "DELEGATO DAL REFERENTE",
		color: indigo["A700"],
		textCol: "#FFF",
		avatarColor: indigo[900],
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN", "ROLE_COMPANY"],
		description: "Ruolo che permette ad un referente di delegare la creazione utenti e la modifica",
	},
	"ROLE_OPERATOR": {
		label: "OPERATORE BASE",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per poter accedere alle funzionalità base dell'applicazione",
	},
	
	"ROLE_FOLLOW_UP": {
		label: "FOLLOW UP", color: pink[500], textCol: "#000", avatarColor: "#8c2985", visibility: ["ROLE_SP_301"],
		description: "Ruolo da assegnare ad un membro del Follow up",
	},
	"ROLE_FRAGILI": {
		label: "FRAGILI", color: red[500], textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ROLE_SP_301"],
		description: "Ruolo da assegnare ad un membro dei fragili",
	},
	"ROLE_INTERVISTE": {
		label: "INTERVISTE", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ROLE_SP_301"],
		description: "Ruolo da assegnare ad un membro delle interviste",
	},
	"ROLE_PROTOCOLLI": {
		label: "PROTOCOLLI", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ROLE_SP_301"],
		description: "Ruolo da assegnare ad un membro dei protocolli",
	},
	"ROLE_POSTA": {
		label: "POSTA", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ROLE_SP_301"],
		description: "Ruolo da assegnare ad un mebro del gruppo posta",
	},
	"ROLE_GRUPPO_SCUOLE": {
		label: "GRUPPO SCUOLE", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ROLE_SP_301"],
		description: "Ruolo da assegnare ad un mebro del gruppo scuole",
	},
	"ROLE_GRUPPO_COMUNITA": {
		label: "GRUPPO COMUNITA", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ROLE_SP_301"],
		description: "Ruolo da assegnare ad un mebro del gruppo comunità",
	},
	
	/*RUOLI PER AZIONI SPECIFICHE*/
	"ROLE_LOCK_MAIL": {
		label: "BLOCCO INVIO MAIL", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ALL"],
		description: "Disabilitazione all'invio delle mail per tutto l'applicativo (Ticket e non).",
	},
	"ROLE_CREATOR": {
		label: "CREA", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ALL"],
		description: "Abilitazione alla creazione di ticket.",
	},
	"ROLE_EVENTS": {
		label: "ABILITATO APPUNTAMENTI",
		color: lime[500],
		textCol: "#757575",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Abilitazione alla creazione di eventi all'interno di Ocean",
	},
	
	/*RUOLI PER CATEGORIE*/
	"ROLE_VACCINI": {
		label: "VACCINI", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ALL"],
		description: "Visibilità della categoria \"Vaccinazioni\" e di tutte le sottocategorie",
	},
	"ROLE_SANZIONI": {
		label: "SANZIONI", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ALL"],
		description: "Visibilità della categoria \"Sanzioni\" e di tutte le sottocategorie",
	},
	"ROLE_ESENZIONI": {
		label: "ESENZIONI", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ALL"],
		description: "Visibilità della categoria \"Esenzioni\" e di tutte le sottocategorie",
	},
	"ROLE_COVID19": {
		label: "COVID 19", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ALL"],
		description: "Visibilità della categoria \"Covid 19\" e di tutte le sottocategorie",
	},
	"ROLE_TAMPONI": {
		label: "TAMPONI", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ALL"],
		description: "Visibilità della categoria \"Tamponi\" e di tutte le sottocategorie",
	},
	"ROLE_RAPIDI": {
		label: "RAPIDI", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ALL"],
		description: "Visibilità della categoria \"Tamponi rapidi\" e di tutte le sottocategorie",
	},
	"ROLE_ISOLAMENTO": {
		label: "ISOLAMENTO", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ALL"],
		description: "Visibilità della categoria \"Isolamento (Caso positivo)\" e di tutte le sottocategorie",
	},
	"ROLE_QUARANTENA": {
		label: "QUARANTENA", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ALL"],
		description: "Visibilità della categoria \"Quarantena (Contatto)\" e di tutte le sottocategorie",
	},
	"ROLE_COMUNITA": {
		label: "COMUNITA'", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ALL"],
		description: "Visibilità della categoria \"Comunità\" e di tutte le sottocategorie",
	},
	"ROLE_RIENTRI": {
		label: "RIENTRI", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ALL"],
		description: "Visibilità della categoria \"Rientro in Italia\" e di tutte le sottocategorie",
	},
	"ROLE_GREEN": {
		label: "CERTIFICAZIONE VERDE", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ALL"],
		description: "Visibilità della categoria \"Certificazione verde covid-19\" e di tutte le sottocategorie",
	},
	"ROLE_SCUOLE": {
		label: "SCUOLE", color: "#757575", textCol: "#FFF", avatarColor: "#792c2c", visibility: ["ALL"],
		description: "Visibilità della categoria \"Scuole\" e di tutte le sottocategorie",
	},
	
	/*RUOLI ASL CHE POSSIAMO ASSEGNARE SOLO NOI*/
	"ROLE_ICT": {
		label: "ICT",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per aggiungere un membro all'ICT",
	},
	"ROLE_SP_301": {
		label: "ASL CITTA' DI TORINO",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per aggiungere un membro all'Asl Città di Torino",
	},
	"ROLE_SP_301_H": {
		label: "ASL CITTA' DI TORINO - Hotspot",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per aggiungere un membro all'Asl Città di Torino - Hotspot",
	},
	"ROLE_SP_203": {
		label: "ASL TORINO 3",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per aggiungere un membro all'Asl Torino 3",
	},
	"ROLE_SP_204": {
		label: "ASL TORINO 4",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per aggiungere un membro all'Asl Torino 4",
	},
	"ROLE_SP_205": {
		label: "ASL TORINO 5",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per aggiungere un membro all'Asl Torino 5",
	},
	"ROLE_SP_206": {
		label: "ASL VERCELLI",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per aggiungere un membro all'Asl Vercelli",
	},
	"ROLE_SP_207": {
		label: "ASL BIELLA",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per aggiungere un membro all'Asl Biella",
	},
	"ROLE_SP_208": {
		label: "ASL NOVARA",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per aggiungere un membro all'Asl Novara",
	},
	"ROLE_SP_209": {
		label: "ASL VERBANO-CUSIO-OSSOLA",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per aggiungere un membro all'Asl VCO",
	},
	"ROLE_SP_210": {
		label: "ASL CUNEO 1",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per aggiungere un membro all'Asl Cuneo 1",
	},
	"ROLE_SP_211": {
		label: "ASL CUNEO 2",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per aggiungere un membro all'Asl Cuneo 2",
	},
	"ROLE_SP_212": {
		label: "ASL ASTI",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per aggiungere un membro all'Asl di Asti",
	},
	"ROLE_SP_213": {
		label: "ASL ALESSANDRIA",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per aggiungere un membro all'Asl di Alessandria",
	},
	"ROLE_WEMAY": {
		label: "WEMAY",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN"],
		description: "Ruolo per aggiungere un membro a WeMay",
	},
	
	/*RUOLI LIVELLI*/
	"ROLE_0": {
		label: "LIVELLO BASE",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN", "ROLE_COMPANY", "ROLE_DELEGATO"],
		description: "Ruolo per il livello BASE nei ticket",
	},
	"ROLE_1": {
		label: "LIVELLO INTERMEDIO",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN", "ROLE_COMPANY", "ROLE_DELEGATO"],
		description: "Ruolo per il livello INTERMEDIO nei ticket",
	},
	"ROLE_2": {
		label: "LIVELLO AVANZATO",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN", "ROLE_COMPANY", "ROLE_DELEGATO"],
		description: "Ruolo per il livello AVANZATO nei ticket",
	},
	"ROLE_3": {
		label: "LIVELLO MEDICO",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN", "ROLE_COMPANY", "ROLE_DELEGATO"],
		description: "Ruolo per il livello MEDICO nei ticket",
	},
	"ROLE_4": {
		label: "LIVELLO AMMINISTRATORE",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN", "ROLE_COMPANY", "ROLE_DELEGATO"],
		description: "Ruolo per il livello AMMINISTRATORE nei ticket",
	},
	"ROLE_MASTER_LEVEL": {
		label: "TUTTI I LIVELLI",
		color: "#757575",
		textCol: "#FFF",
		avatarColor: "#792c2c",
		visibility: ["ROLE_ADMIN", "ROLE_SUPERADMIN", "ROLE_COMPANY", "ROLE_DELEGATO"],
		description: "Ruolo per abilitare a tutti i livelli",
	},
}
